import styled from 'styled-components';
import { colors } from '../css';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => {
    switch (props.background) {
      case 'dashboard':
        return colors.colorGrey05;
      case 'none':
      default:
        return 'none';
    }
  }};
`;
